// extracted by mini-css-extract-plugin
export default {"wrapper":"Section4_wrapper__MFnBC","wrapperInner":"Section4_wrapperInner__pgvVn","h2":"Section4_h2__sR9Kv"};